import { useQuery } from '@tanstack/react-query'

import { type VisionPlan } from 'components/member_onboarding_v2/types'
import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

interface VisionPlansResponse {
  data: Array<VisionPlan>;
}

export function useGetVisionPlans ({
  enrollmentEventId,
  enabled = true,
}: {
  enrollmentEventId: string;
  enabled?: boolean;
}) {
  return useQuery<VisionPlansResponse, GrapeAPIErrorType>({
    queryKey: ['enrollmentEvent', enrollmentEventId, 'vision_plans'],
    queryFn: async () => {
      const response = await fetchWithHeaders(
        `/api/web/member_onboarding/enrollment_events/${enrollmentEventId}/vision_plans`
      )
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
          requestId: response.headers.get('x-request-id') ?? undefined
        })
      }
      return response.json()
    },
    retry: false,
    enabled,
  })
}
